import { ethers } from "ethers"
import { ARBITRUM_RPC_URL, BASE_RPC_URL, ETHEREUM_RPC_URL } from "config"
import { ArtBlocksChainId } from "contractConfig"

const RPC_URLS: Record<ArtBlocksChainId, string> = {
  1: ETHEREUM_RPC_URL,
  42161: ARBITRUM_RPC_URL,
  8453: BASE_RPC_URL,
}

const NETWORKS: Record<ArtBlocksChainId, { chainId: number; name: string }> = {
  1: { chainId: 1, name: "homestead" },
  42161: { chainId: 42161, name: "arbitrum" },
  8453: { chainId: 8453, name: "base" },
}

const providers: Partial<Record<ArtBlocksChainId, ethers.providers.StaticJsonRpcProvider>> = {}

export const getReadOnlyProvider = (chainId: ArtBlocksChainId) => {
  if (!providers[chainId]) {
    providers[chainId] = new ethers.providers.StaticJsonRpcProvider(RPC_URLS[chainId], NETWORKS[chainId])
  }

  return providers[chainId]!
}
